import ApiService from '@api/api-service';

let VCA = VCA || {};

VCA.IndividualPetProfile = (function ($) {

    let ui = {};

    function cacheUI() {
        ui.$ApplyUpdatesBtn = $('#ApplyPetProfileChangesBtn');
        ui.$CancelBtn = $('#CancelPetProfileChangesBtn');
        ui.$EditBtn = $('.petpage-pet-profile__edit-btn');
        ui.$EditableContainer = $('#EditablePetProfile');
        ui.$RequestVerificationToken = $('input[name="__RequestVerificationToken"]').val();
        ui.$DateOfBirth = $('#PetProfileDatepicker').data('date');
        ui.$InputEl = $('input');
        ui.$SelectEl = $('select');
        ui.$EditableMainContent = $('.petpage-pet-profile__right-main');
        ui.$Loader = $('.petpage-pet-profile__loader');
        ui.$ErrorMessage = $('#PetProfileAPIErrorMsg');

        //Select Option Elements
        ui.$SpeciesInput = $('#PetProfileSpecies');
        ui.$DatePickerInput = $('#PetProfileDatepicker');
        ui.$PrimaryBreedInput = $('#PetProfilePrimaryBreed');
        ui.$SecondaryBreedInput = $('#PetProfileSecondaryBreed');

        //Updated Selected Input data-names
        ui.$UpdatedSpeciesValue;
        ui.$UpdatedDOB;
        ui.$UpdatedPrimaryBreedValue;
        ui.$UpdatedSecondaryBreedValue;

        //Item Info Values Elements
        ui.$PetProfileSpeciesText = $('#PetProfileSpeciesText');
        ui.$PetProfileDOBText = $('#PetProfileDOBText');
        ui.$PetProfilePrimaryBreedText = $('#PetProfilePrimaryBreedText');
        ui.$PetProfileSecondaryBreedText = $('#PetProfileSecondaryBreedText');

        //Selected Option Elements on Load
        ui.$SpeciesOnLoadValue;
        ui.$DateOnLoadValue;
        ui.$PrimaryBreedOnLoadValue;
        ui.$SecondaryBreedOnLoadValue;
    }

    function bindEvents() {
        ui.$EditBtn.on('click', initEditInputFields);
        ui.$ApplyUpdatesBtn.on('click', applyUpdates);
        ui.$InputEl.on('change', hideDOBErrorMessage);
        ui.$SelectEl.on('change', hideSelectErrorMessages);
        ui.$CancelBtn.on('click', resetMainContainer);
    }

    function saveSelectedValuesOnLoad() {
        ui.$SpeciesOnLoadValue = ui.$SpeciesInput.find(':selected').val();
        ui.$PrimaryBreedOnLoadValue = ui.$PrimaryBreedInput.find(':selected').val();
        ui.$SecondaryBreedOnLoadValue = ui.$SecondaryBreedInput.find(':selected').val();
        ui.$DateOnLoadValue = ui.$DatePickerInput.data('date');
    }

    function hideDOBErrorMessage(e) {
        const target = $(e.currentTarget);
        let el = $(target)[0];
        let dynamicDateInputEl = $('.flatpickr.petpage-pet-profile__dob-input.form-control.input');

        ui.$ApplyUpdatesBtn.addClass('active');
        dynamicDateInputEl.removeClass('error');
        $(el).closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').hide();
    }

    function hideSelectErrorMessages(e) {
        const el = $(e.currentTarget);

        ui.$ApplyUpdatesBtn.addClass('active');
        el.removeClass('error');
        el.closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').hide();
    }

    function initEditInputFields() {
        ui.$ErrorMessage.hide();
        ui.$EditBtn.hide();
        ui.$ApplyUpdatesBtn.show();
        ui.$CancelBtn.show();

        //Hide item-info containers
        ui.$EditableContainer.find('.item-info').each((idx,el) => {
            $(el).hide();
        });

        //Show input-wrapper containers
        ui.$EditableContainer.find('.petpage-pet-profile__input-wrapper').each((idx,el) => {
            $(el).show();
        });
    }

    function initDatePicker() {
        ui.$DatePickerInput.flatpickr({
            altInput: true,
            altFormat: "m/d/Y",
            dateFormat: "Y-m-d",
            maxDate: 'today',
            disableMobile: true,
            defaultDate: [ui.$DateOfBirth]
        });
    }

    function applyUpdates() {
        ui.$ApplyUpdatesBtn.removeClass('active');

        let speciesValue = ui.$SpeciesInput.val();
        let dateValue = ui.$DatePickerInput.val();
        let primaryBreedValue = ui.$PrimaryBreedInput.val();
        let secondaryBreedValue = ui.$SecondaryBreedInput.val();

        ui.$UpdatedSpeciesValue = ui.$SpeciesInput.find('option:selected').data('name');
        ui.$UpdatedPrimaryBreedValue = ui.$PrimaryBreedInput.find('option:selected').data('name');
        ui.$UpdatedSecondaryBreedValue = ui.$SecondaryBreedInput.find('option:selected').data('name');

        let dynamicDateInputEl = $('.flatpickr.petpage-pet-profile__dob-input.form-control.input');

        let speciesValid = false;
        let dateValid = false;
        let primaryBreedValid = false;
        let secondaryBreedValid = true;

 
        //validate species value
        if (speciesValue.trim() == '') {
            ui.$SpeciesInput.addClass('error');
            ui.$SpeciesInput.closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').show();
            speciesValid = false;
        } else {
            ui.$SpeciesInput.removeClass('error');
            ui.$SpeciesInput.closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').hide();
            speciesValid = true;
        }

        //validate date value
        if (dateValue.trim() == '') {
            dynamicDateInputEl.addClass('error');
            dynamicDateInputEl.closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').show();
            dateValid = false;
        } else {
            dynamicDateInputEl.removeClass('error');
            dynamicDateInputEl.closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').hide();
            dateValid = true;
        }

        //validate primary breed value
        if (ui.$PrimaryBreedInput.children().length == 0) {
            primaryBreedValid = true;
            primaryBreedValue = 0;
        } else {
            if (primaryBreedValue.trim() == '') {
                ui.$PrimaryBreedInput.addClass('error');
                ui.$PrimaryBreedInput.closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').show();
                primaryBreedValid = false;
            } else {
                ui.$PrimaryBreedInput.removeClass('error');
                ui.$PrimaryBreedInput.closest('.petpage-pet-profile__input-wrapper').find('.input-error-text').hide();
                primaryBreedValid = true;
            }
        }

        //validate secondary breed value
        if (ui.$SecondaryBreedInput.length == 0) {
            secondaryBreedValue = 0;
            return;
        } 

        ui.$SpeciesInput.attr('value',speciesValue);
        ui.$DatePickerInput.attr('value',dateValue);
        ui.$PrimaryBreedInput.attr('value', primaryBreedValue);
        ui.$SecondaryBreedInput.attr('value', secondaryBreedValue);


        if (speciesValid && dateValid && primaryBreedValid && secondaryBreedValid) {
        
            let payload = {
                petId: petId,
                speciesId: speciesValue,
                primaryBreedId: primaryBreedValue,
                secondaryBreedId: secondaryBreedValue,
                dob: dateValue,
                datasourceId: datasourceId,
                '__RequestVerificationToken': ui.$RequestVerificationToken
            }

            updatePetProfileAPI(payload);
        }

    }

    async function updatePetProfileAPI(payload) {
        ui.$Loader.show();
        ui.$EditableMainContent.hide();

        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
            
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }
        
        const url = `/myvca-api/update-pet-profile`;
        let api = new ApiService(url);
        const { data, success, error } = await api.post(searchParams(payload), axiosConfig);


        if (!success || (error !== null && error !== '')) {
            resetMainContainer();
            ui.$ErrorMessage.html(error).show();
        } else { 
            let htmlPartialRendering = data;

            ui.$EditableContainer.empty();
            ui.$EditableContainer.html(htmlPartialRendering);    

            //unbind events
            ui.$EditBtn.unbind('click');
            ui.$ApplyUpdatesBtn.unbind('click');
            ui.$InputEl.unbind('change');
            ui.$SelectEl.unbind('change');
            ui.$CancelBtn.unbind('click');

            //rebind events 
            cacheUI();
            ui.$EditBtn.on('click', initEditInputFields);
            ui.$ApplyUpdatesBtn.on('click', applyUpdates);
            ui.$InputEl.on('change', hideDOBErrorMessage);
            ui.$SelectEl.on('change', hideSelectErrorMessages);
            ui.$CancelBtn.on('click', resetMainContainer);     
            initDatePicker();  
        }
    }

    function resetToSelectedValues() {
            ui.$SpeciesInput.find('option:selected').removeAttr('selected');
            ui.$SpeciesInput.find(`option[value="${ui.$SpeciesOnLoadValue}"]`).prop('selected', true);

            ui.$PrimaryBreedInput.find('option:selected').removeAttr('selected');
            ui.$PrimaryBreedInput.find(`option[value="${ui.$PrimaryBreedOnLoadValue}"]`).prop('selected', true);

            ui.$SecondaryBreedInput.find('option:selected').removeAttr('selected');
            ui.$SecondaryBreedInput.find(`option[value="${ui.$SecondaryBreedOnLoadValue}"]`).prop('selected', true);

            initDatePicker();
    }

    function resetMainContainer() {
        ui.$Loader.hide();
        ui.$EditBtn.show();
        ui.$ApplyUpdatesBtn.hide();
        ui.$CancelBtn.hide();
        resetToSelectedValues();

        //Show item-info containers
        ui.$EditableContainer.find('.item-info').each((idx,el) => {
            $(el).show();
        });

        //Hide input-wrapper containers
        ui.$EditableContainer.find('.petpage-pet-profile__input-wrapper').each((idx,el) => {
            $(el).hide();
        });

        ui.$EditableMainContent.show();
    }

    function init() {
        if ($('.petpage-pet-profile').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
        initDatePicker();
        saveSelectedValuesOnLoad();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.IndividualPetProfile.init();
    });
});
